import React from 'react'
import { NoDataFarmI } from '../../assets/icons/icon'
import { cn } from '../../lib/utils'

const NoDataFound = ({ text, desc, icon, showButton, buttonText, handleClick,iconClass }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16">
      <div className={cn("w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4",iconClass)}>
        {icon}
      </div>
      <h3 className="text-lg font-medium text-gray-900 mb-2">{text}</h3>
      {desc &&
        <p className="text-gray-500 text-center max-w-md">
          {desc}
        </p>
      }
      {showButton && (
        <button
          onClick={handleClick}
          className="mt-4 inline-flex items-center px-4 py-2 bg-primary text-white text-sm font-medium rounded-lg hover:bg-primary/90 transition-colors duration-200"
        >
          {buttonText}
        </button>
      )}
    </div>
  )
}

export default NoDataFound
